import { Component, Input, OnInit } from '@angular/core';
import { OptimizelyService } from '@app/shared/services/optimizely/optimizely.service';

@Component({
  standalone: false,
  selector: 'sbnb-review-ratings',
  templateUrl: './review-ratings.component.html',
  styleUrls: ['./review-ratings.component.scss'],
})
export class ReviewRatingsComponent implements OnInit {
  @Input() review: {
    private_feedback: string;
    review: {
      bad_review: boolean;
      grades: {
        cleanliness: number;
        communication: number;
        rating: number;
        recommend: boolean;
        respect_house_rules: number;
      };
      category_tags?: {
        cleanliness_tags: string[];
        respect_house_rules_tags: string[];
        communication_tags: string[];
      };
    };
  };

  @Input() readOnly: boolean;

  public selectedTags: { [category: string]: Set<string> } = {
    cleanliness: new Set(),
    respect_house_rules: new Set(),
    communication: new Set(),
  };

  public readonly Array = Array;
  public tagsEnabled = false;

  constructor(
    private optimizelyService: OptimizelyService
  ) {
    this.optimizelyService.reviewCategoryTagsEnabled$.subscribe(
      enabled => this.tagsEnabled = enabled
    );
  }

  ngOnInit(): void {
    // Initialize tags from review if they exist
    if (this.review.review.category_tags) {
      this.selectedTags.cleanliness = new Set(this.review.review.category_tags.cleanliness_tags || []);
      this.selectedTags.respect_house_rules = new Set(this.review.review.category_tags.respect_house_rules_tags || []);
      this.selectedTags.communication = new Set(this.review.review.category_tags.communication_tags || []);
    }
  }

  public onTagsChange(category: string, selectedTags: string[]): void {
    this.selectedTags[category] = new Set(selectedTags);
    // Update the review object to keep it in sync
    if (!this.review.review.category_tags) {
      this.review.review.category_tags = {
        cleanliness_tags: [],
        respect_house_rules_tags: [],
        communication_tags: [],
      };
    }
    this.review.review.category_tags[`${category}_tags`] = selectedTags;
  }
}
